import { Component, Inject } from '@angular/core';
import { ListBase } from "../shared/list.base";
import { CrewPermissionsService } from '../../core/crew-permissions.service';

@Component({
    selector: 'crew-jobtitles',
    template: require('../shared/list-view.html')
})
export class JobTitles extends ListBase<Nema.Crew.Model.JobType> {

    constructor(
        @Inject("jobTitles") jobTitles: Nema.Crew.Model.JobType[],
        crewPermissionsService: CrewPermissionsService) {

        super(jobTitles, crewPermissionsService);
    }

    public newEntityState = "app.settings.jobtitles.new";

    public editEntityState = "app.settings.jobtitles.detail";

    public entityName = "Job Title";

    public entityNames = "Job Titles";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/jobtitles/jobtitles.component.ts